import { createSlice } from "@reduxjs/toolkit";
import { getEmployeesList } from "../../reduxApi/admin/EmployeesReduxApi";

const employeesSlice = createSlice({
    name: 'employees',
    initialState: {
        status: 'idel',
        isFiltered: false,
        employees: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteEmployeesAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.employees.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.employees.splice(index, 1);
                }
            });
        },
        updateEmployeesAction: (state, action) => {
            const index = state.employees.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.employees.splice(index, 1, { employeess: action.payload })
            }
        },
        addEmployeesAction: (state, action) => {
            console.log("action--->",action.payload);
            
            const temp = action.payload;
            console.log("temp",temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID",temp.ROWID);
            
            state.employees.unshift({ employeess: temp }); //add new data at beginning of array 
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getEmployeesList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getEmployeesList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.employees = action.payload.data.employees;
            })
            .addCase(getEmployeesList.rejected, (state, action) => {
                state.status = 'rejected'
            })
    }
})
export const { deleteEmployeesAction, updateEmployeesAction, addEmployeesAction, setFilteredStatus } = employeesSlice.actions
export default employeesSlice.reducer